import { ArrowRight, Eye, EyeOff, Lock, Mail } from 'lucide-react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { login } from '../api';

export default function Login({ onAuth, onIrARegistro }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [cargando, setCargando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setCargando(true);
    try {
      const data = await login(email, password);
      onAuth(data.empresa);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo iniciar sesión.');
    } finally {
      setCargando(false);
    }
  }

  return (
    <div className="auth-card">
      <div className="auth-icono"><ArrowRight size={22} /></div>
      <h2>Bienvenido de vuelta</h2>
      <p className="auth-subtitulo">Hub Financiero — Generador de Cheques</p>

      <form onSubmit={handleSubmit}>
        <label>Correo electrónico</label>
        <div className="input-con-icono">
          <Mail size={16} />
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tucorreo@empresa.com" required />
        </div>

        <label>Contraseña</label>
        <div className="input-con-icono">
          <Lock size={16} />
          <input
            type={mostrarPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña"
            required
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setMostrarPassword((v) => !v)}
            aria-label={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          >
            {mostrarPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>

        <button className="btn-primary" type="submit" disabled={cargando}>
          <ArrowRight size={16} /> {cargando ? 'Ingresando…' : 'Iniciar sesión'}
        </button>
      </form>
      <p className="auth-switch">
        ¿No tienes cuenta? <button type="button" onClick={onIrARegistro}>Regístrate</button>
      </p>
    </div>
  );
}
